<template>
    <tr v-if="collapseActive" class="workflows__log_table_item_collapse_table">
        <td class="workflows__log_table_item_collapse_table_wrapper" colspan="6">
            <table>
                <list-table-head :labels="['Learner', 'Reason']"></list-table-head>
                <tbody>
                <lms-superadmin-workflows-log-table-item-collapse-table-item
                    :item="item"
                ></lms-superadmin-workflows-log-table-item-collapse-table-item>
                </tbody>
            </table>
        </td>
    </tr>
</template>

<script>
import LmsSuperadminWorkflowsLogTableItemCollapseTableItem from '@/components/lms/superadmin/workflows/log/LmsSuperadminWorkflowsLogTableItemCollapseTableItem'
import ListTableHead from '@/components/default/shared/ListTableHead'

export default {
  name: 'lms-superadmin-workflows-log-table-item-collapse-table',
  components: { ListTableHead, LmsSuperadminWorkflowsLogTableItemCollapseTableItem },
  data () {
    return {
      requestPending: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/workflows/_workflowslogtableitemcollapse.scss";
</style>
